import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { Locations } from "interfaces/enums";
import { Skeleton } from "../ui/skeleton";

const RequireAuth = ({
  children,
  redirectTo,
}: {
  children: any;
  redirectTo: Locations;
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div>
        <Skeleton className="h-16 w-full" />
      </div>
    );
  }

  return user ? children : <Navigate to={redirectTo} />;
};

export default RequireAuth;
